<template>
  <b-modal v-model="show" centered size="md" @show="onShow" @ok="onOk">
    <template #modal-title>
      <h3 class="font-weight-bold">Select Trades</h3>
    </template>

    <div v-if="isLoading" class="text-center py-5">
      <digger-loader />
    </div>
    <b-row v-if="!isLoading">
      <b-col>
        <b-form-input
          v-model.lazy="searchQuery"
          placeholder="Type to search trades"
          @input="onSearchQueryChange"
          class="mb-2"
          autofocus
          clearable
        />
        <div class="text-danger" style="height: 32px">
          <span v-if="isMaxReached">
            You can only select up to 3 options.
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="!isLoading" class="overflow-auto" style="height: 480px">
      <b-col>
        <div v-for="trade in trades" :key="trade.id">
          <!-- prettier-ignore -->
          <b-form-group v-if="searchQuery === '' || trade.name.toLowerCase().includes(searchQuery.toLowerCase()) || pickedTradeIds.includes(trade.id)">
              <b-form-checkbox v-model="pickedTradeIds" :value="trade.id" :checked="isChecked(trade.id)" @change="onCheckChange()">
                {{ trade.name }}
              </b-form-checkbox>
            </b-form-group>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'TradesPickerModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    existingTrades: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: false,
      pickedTradeIds: [],
      searchQuery: '',
      isMaxReached: false,
    }
  },

  computed: {
    ...mapState({
      trades: (state) => state.trade.trades,
    }),

    show: {
      get() {
        return this.showModal
      },
      set() {
        this.resetData()
        this.$emit('onCloseTradesPickerModal')
      },
    },
  },

  methods: {
    ...mapActions({
      getPickerValues: 'trade/getPickerValues',
    }),

    async onShow() {
      // if (this.trades.length === 0) {
      this.isLoading = true

      try {
        await this.getPickerValues()
        this.resetData()
      } catch (e) {
        this.$bvToast.toast('Could not load trades. Please try again.', {
          variant: 'danger',
          title: 'Error',
        })
      } finally {
        this.isLoading = false
      }
      // } else this.resetData()
    },

    // prettier-ignore
    sortTrades() {
      // Sort trade name, then by checked status
      this.trades.sort((a, b) => (a.name < b.name ? -1 : 1))
      this.trades.sort((a, b) => this.pickedTradeIds.includes(b.id) - this.pickedTradeIds.includes(a.id))
    },

    isChecked(id) {
      return this.pickedTradeIds.includes(id)
    },

    onSearchQueryChange() {
      this.sortTrades()
    },

    onCheckChange() {
      this.isMaxReached = false

      if (this.pickedTradeIds.length > 3) {
        this.isMaxReached = true
        this.pickedTradeIds.pop()
      }
    },

    onOk() {
      this.$emit('onTradesPicked', {
        trades: this.trades
          .sort((a, b) => (a.name < b.name ? -1 : 1))
          .filter((trade) => this.pickedTradeIds.includes(trade.id))
          .map((trade) => trade.name)
          .join(', '),
      })
    },

    resetData() {
      // Generate picked trade ids
      this.pickedTradeIds = this.existingTrades
        ? this.existingTrades
            .split(',')
            .map((tradeName) => {
              // prettier-ignore
              const trade = this.trades.find((t) => t.name.trim() === tradeName.trim())
              return trade ? trade.id : null
            })
            .filter((id) => id !== null)
        : []

      this.sortTrades()
      this.searchQuery = ''
      this.isMaxReached = false
    },
  },
}
</script>
